<template>
  <div class="enroll-query" v-loading="queryLoading">
    <div class="query-form">
      <div class="title">{{ year }}河北传媒学院高考录取查询</div>
      <div class="form-body">
        <el-input
          v-model="number"
          class="input"
          placeholder="请输入考生号"
        ></el-input>
        <el-input
          v-model="idCard"
          class="input"
          placeholder="请输入身份证号"
        ></el-input>
        <div class="input code-wrapper">
          <el-input v-model="authCode" placeholder="验证码"></el-input>
          <div class="code" @click="generageRandomCode">{{ randomCode }}</div>
        </div>

        <div class="btns">
          <div class="btn-reset" @click="handleReset">重置</div>
          <div class="btn-search" @click="handleQuery">查询</div>
        </div>

        <div class="tip">
          <div class="line"></div>
          <div class="tip-text"><i class="el-icon-warning"></i> 提示</div>
          <div class="line"></div>
        </div>

        <div class="desc">
          <div>{{ year }}年录取工作正在进行，请考生和家长耐心等待。</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { queryEnroll } from "../../../services/enroll";

export default {
  name: "EnrollQuery",
  data() {
    return {
      year: null,
      number: "", // 考生号
      idCard: "", // 身份证
      authCode: "", // 验证码
      randomCode: "", // 随机验证码

      queryLoading: false,
    };
  },
  created() {
    this.year = new Date().getFullYear();
    this.generageRandomCode();
  },
  methods: {
    handleReset() {
      this.number = ""; // 考生号
      this.idCard = ""; // 身份证
      this.authCode = ""; // 验证码
      this.generageRandomCode();
    },
    async handleQuery() {
      if (!this.number.trim()) {
        this.$message.error("请输入考生号");
        return;
      }

      if (!this.idCard.trim()) {
        this.$message.error("请输入身份证号");
        return;
      }

      if (this.authCode.toUpperCase() !== this.randomCode.split(" ").join("")) {
        this.$message.error("请输入正确的验证码");
        return;
      }

      this.queryLoading = true;
      try {
        const res = await queryEnroll(this.number, this.idCard);
        this.$router.push({
          name: "enrollResult",
          query: { idCard: this.idCard, number: this.number },
        });
      } catch (error) {
      } finally {
        this.queryLoading = false;
      }
    },

    generageRandomCode() {
      const arr = "0123456789abcdefghijklmnopqrstuvwxyz";
      const c = [];
      for (let i = 0; i < 4; i++) {
        const char = arr[Math.floor(Math.random() * arr.length)];
        c.push(char);
      }
      this.randomCode = c.join(" ").toUpperCase();
    },
  },
};
</script>

<style lang="scss" scoped>
.enroll-query {
  background: #fff;
  position: relative;
  height: 518px;

  .query-form {
    position: absolute;
    background: #ffffff;
    border: 1px solid #700005;
    border-radius: 8px;
    width: 800px;
    max-width: 100%;
    overflow: hidden;
    left: 0;
    right: 0;
    margin: 0 auto;
    top: -64px;

    .title {
      font-size: 22px;
      color: #fff;
      height: 64px;
      text-align: center;
      line-height: 64px;
      background: #700005;
      opacity: 1;
    }
    .form-body {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-top: 28px;
      .input {
        width: 360px;
        margin-bottom: 24px;
      }
      .code-wrapper {
        display: flex;
        .code {
          width: 120px;
          height: 40px;
          line-height: 40px;
          text-align: center;
          margin-left: 16px;
          background: #f4f6fa;
          cursor: pointer;
        }
      }

      .btns {
        display: flex;
        width: 360px;
        margin-top: 10px;
        margin-bottom: 40px;
      }
      .btn-reset,
      .btn-search {
        cursor: pointer;
        flex: 1;
        box-sizing: border-box;
        height: 48px;
        line-height: 48px;
        text-align: center;
        opacity: 1;
        border-radius: 8px;
        font-size: 18px;
      }
      .btn-reset {
        border: 2px solid #8f000b;
        margin-right: 16px;
        color: #8f000b;
      }
      .btn-search {
        background: #8f000b;
        color: #fff;
      }

      .tip {
        width: 100%;
        display: flex;
        align-items: center;
        color: #8f000b;
        .line {
          flex: 1;
          border-top: 2px dashed #8f000b;
        }
        .tip-text {
          margin: 0 10px;
        }
      }

      .desc {
        text-align: center;
        color: #8f000b;
        font-size: 14px;
        padding: 20px;
        > div:first-child {
          margin-bottom: 6px;
        }
      }
    }
  }
}

@media only screen and (max-width: 600px) {
  .enroll-query {
    height: 400px;
    .query-form {
      overflow: hidden;
      width: 90%;
      top: -40px;
      .title {
        font-size: 14px;
        height: 40px;
        line-height: 40px;
      }
      .form-body {
        padding-top: 20px;
        .input {
          width: 80%;
          margin-bottom: 16px;
        }

        .btns {
          width: 80%;
          margin-top: 5px;
          margin-bottom: 20px;
        }
        .btn-reset,
        .btn-search {
          height: 36px;
          line-height: 36px;
          border-radius: 6px;
          font-size: 16px;
        }

        .tip {
          width: 100%;
          display: flex;
          align-items: center;
          color: #8f000b;
          .line {
            flex: 1;
            border-top: 2px dashed #8f000b;
          }
          .tip-text {
            margin: 0 8px;
          }
        }

        .desc {
          color: #8f000b;
          font-size: 13px;
          padding: 10px;
          > div:first-child {
            margin-bottom: 6px;
          }
        }
      }
    }
  }
}
</style>